'use client';

import { usePathname } from 'next/navigation';
import { useCallback, useRef } from 'react';
import {
	PORTFOLIO_PAGE_DEFAULT_TAB,
	PORTFOLIO_PAGE_TAB_OPTIONS,
} from 'src/components/PortfolioPage/consts';
import {
	isPortfolioPageTabValue,
	PortfolioPageTabValue,
} from 'src/components/PortfolioPage/types';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import ScrollShadows from 'src/components/ScrollShadows';
import useGoToRoute from 'src/hooks/useGoToRoute';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';

export default function PortfolioTabs() {
	const isMobileScreenSize = useIsMobileScreenSize();

	const goToRoute = useGoToRoute();

	const scrollableRef = useRef<HTMLDivElement>(null);

	const handleTabChange = useCallback(
		(tabValue: PortfolioPageTabValue) => {
			const newRoute = `/portfolio/${tabValue}`;

			goToRoute(newRoute);
		},
		[goToRoute]
	);

	const pathname = usePathname();
	const routePathChunk = pathname?.split('/')?.[2];
	const activeTab = (() => {
		const tabFromPath = routePathChunk;

		if (!tabFromPath || !isPortfolioPageTabValue(tabFromPath)) {
			return PORTFOLIO_PAGE_DEFAULT_TAB;
		}

		return tabFromPath;
	})();

	return (
		<div className="flex items-center justify-between border-b border-stroke-divider">
			<ScrollShadows
				className="w-full"
				scrollableRef={scrollableRef}
				gradientFromClassName="from-main-bg"
			>
				<div className="hidden-scroll overflow-x-auto" ref={scrollableRef}>
					<Tabs
						size={isMobileScreenSize ? 'md' : 'lg'}
						className="w-fit"
						options={PORTFOLIO_PAGE_TAB_OPTIONS}
						activeTab={activeTab}
						onTabChange={handleTabChange}
						dataTestId="portfolio-tabs"
						tabTestIdPrefix="portfolio-tab"
					/>
				</div>
			</ScrollShadows>
		</div>
	);
}
